export default __webpack_public_path__ + "static/media/73.caec1029.svg";